import clsx from 'clsx'
import React, { FC, PropsWithChildren } from 'react'

import { Link, LinkProps } from '@Components/Link'

import { Variant } from './index'
import styles from './TrustIcon.module.scss'

export interface TrustIconProps {
  variant: Variant
}

export const Icons: FC<PropsWithChildren<TrustIconProps>> = ({
  children, variant,
}) => (
  <div className={clsx(styles.trustIcon, variant === 'footer' && styles.footer)}>
    {children}
  </div>
)

export const IconLink: FC<PropsWithChildren<LinkProps & TrustIconProps>> = ({
  children, variant, ...props
}) => (
  <Link className={clsx(styles.trustIcon, variant === 'footer' && styles.footer)} {...props}>
    {children}
  </Link>
)

export const getMobileNavEvent = (destPageTypeId: string, variant: Variant) => {
  if (variant !== 'mobile-menu') {
    return undefined
  }

  return {
    dest_page_type: 'external',
    dest_page_type_id: destPageTypeId,
    source_id: 'mobile_menu_footer',
  }
}
